import React from 'react';
import styled from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3;
/**
 * Standard div with opinionated box-sizing.
 */


var Box = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n"])));
Box.displayName = 'Box';
/**
 * Flex container
 */

var Flex = styled(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
Flex.displayName = 'Flex';
/**
 * Grid container
 */

var Grid = styled(Box)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: grid;\n"])));
Grid.displayName = 'Grid';

var _templateObject$1;
/**
 * Customize the modal overlay with props.
 */


var Overlay = styled(Flex)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  height: ", ";\n  min-height: ", ";\n  position: ", ";\n  background-color: ", ";\n  bottom: ", ";\n  top: ", ";\n  left: ", ";\n  right: ", ";\n  z-index: ", ";\n  ", ";\n"])), function (props) {
  return props.height ? props.height : 'auto';
}, function (props) {
  return props.minHeight ? props.minHeight : 0;
}, function (props) {
  return props.position ? props.position : 'fixed';
}, function (props) {
  return props.bgColor ? props.bgColor : 'rgba(0, 0, 0, 0.5)';
}, function (props) {
  return props.bottom ? props.bottom : 0;
}, function (props) {
  return props.top ? props.top : 0;
}, function (props) {
  return props.left ? props.left : 0;
}, function (props) {
  return props.right ? props.right : 0;
}, function (props) {
  return props.zIndex ? props.zIndex : '9999';
}, function (props) {
  return props.center && "\n    align-items: center;\n    justify-content: center;\n  ";
});
Overlay.displayName = 'Overlay';
/**
 * Only one child is supported.
 * Child component must handle closing the modal.
 *
 * Default is full screen modal with child component in TLHC.
 * Add 'center' prop to center child component in the modal.
 * Otherwise, child styling controls child component position.
 *
 * Example: Full screen modal with custom bgColor and centered content
 *  <Modal bgColor='rgba(12, 12, 128, 0.5)' center>
 *    <YourComponent />
 * </Modal>
 */

var Modal = function Modal(props) {
  return (
    /*#__PURE__*/
    React.createElement(Overlay, props)
  );
};

Modal.displayName = 'Modal';
export { Modal };